import { stringify } from '@angular/compiler/src/util';
import { Injectable } from '@angular/core';
import { LocaleService } from './locale.service';

@Injectable({
  providedIn: 'root'
})
export class WorkWeekService 
{
  _workWeek:any;

  constructor(
    private localeservice: LocaleService
  ) { }

  public Initialize(workWeek:any)
  {
    this._workWeek = workWeek;
  }

  public isOpen() : boolean
  {
    if(this._workWeek)
    {
      const now = new Date();

      const today = now.getDay();

      if(this.isWorkDay(today))
      {
        //Get Start Time
        const startTimeString = this.getStartTimeString(today);

        const startTimeStringSplit = startTimeString.split(':');
        
        const startTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), Number(startTimeStringSplit[0]), Number(startTimeStringSplit[1]), Number(startTimeStringSplit[2]));

        //Get End Time
        const endTimeString = this.getEndTimeString(today);

        const endTimeStringSplit = endTimeString.split(':');
        
        const endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), Number(endTimeStringSplit[0]), Number(endTimeStringSplit[1]), Number(endTimeStringSplit[2]));

        return now >= startTime && now < endTime;
      }
      else
        return false
    }
    else
      return false;
  }

  isWorkDay(dayOfTheWeek:Number) : boolean
  {
    switch(dayOfTheWeek)
    {
      case 0:
        if(typeof this._workWeek.Sunday.IsWorkDay === 'boolean')
          return this._workWeek.Sunday.IsWorkDay;
        else return false;
      case 1:
        if(typeof this._workWeek.Monday.IsWorkDay === 'boolean')
          return this._workWeek.Monday.IsWorkDay;
        else 
          return false;
      case 2:
        if(typeof this._workWeek.Tuesday.IsWorkDay === 'boolean')
          return this._workWeek.Tuesday.IsWorkDay;
        else 
          return false;
      case 3:
        if(typeof this._workWeek.Wednesday.IsWorkDay === 'boolean')
          return this._workWeek.Wednesday.IsWorkDay;
        else 
          return false;
      case 4:
        if(typeof this._workWeek.Thursday.IsWorkDay === 'boolean')
          return this._workWeek.Thursday.IsWorkDay;
        else 
          return false;
      case 5:
        if(typeof this._workWeek.Friday.IsWorkDay === 'boolean')
          return this._workWeek.Friday.IsWorkDay;
        else 
          return false;
      case 6:
        if(typeof this._workWeek.Saturday.IsWorkDay === 'boolean')
          return this._workWeek.Saturday.IsWorkDay;
        else 
          return false;
      default:
        return false;
    }
  }

  getStartTimeString(dayOfTheWeek:Number) : string
  {
    switch(dayOfTheWeek)
    {
      case 0:
        return String(this._workWeek.Sunday.StartTime);
      case 1:
        return String(this._workWeek.Monday.StartTime);
      case 2:
        return String(this._workWeek.Tuesday.StartTime);
      case 3:
        return String(this._workWeek.Wednesday.StartTime);
      case 4:
        return String(this._workWeek.Thursday.StartTime);
      case 5:
        return String(this._workWeek.Friday.StartTime);
      case 6:
        return String(this._workWeek.Saturday.StartTime);
      default:
        return '?';
    }
  }

  getEndTimeString(dayOfTheWeek:Number) : string
  {
    switch(dayOfTheWeek)
    {
      case 0:
        return String(this._workWeek.Sunday.EndTime);
      case 1:
        return String(this._workWeek.Monday.EndTime);
      case 2:
        return String(this._workWeek.Tuesday.EndTime);
      case 3:
        return String(this._workWeek.Wednesday.EndTime);
      case 4:
        return String(this._workWeek.Thursday.EndTime);
      case 5:
        return String(this._workWeek.Friday.EndTime);
      case 6:
        return String(this._workWeek.Saturday.EndTime);
      default:
        return '?';
    }
  }

  getWorkWeekSummary()
  {
    if(this._workWeek)
    {
      var lines = new Array<string>();

      for (let index = 0; index < 7; index++) 
      {
        var isWorkDay = this.isWorkDay(index);

        var prefix = this.getWeekDayString(index);

        var sufix = "";

        if(isWorkDay === true)
        {
          const now = new Date();

          const startTimeString = this.getStartTimeString(index);

          const startTimeStringSplit = startTimeString.split(':');
          
          const startTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), Number(startTimeStringSplit[0]), Number(startTimeStringSplit[1]), Number(startTimeStringSplit[2]));

          const endTimeString = this.getEndTimeString(index);

          const endTimeStringSplit = endTimeString.split(':');
          
          const endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), Number(endTimeStringSplit[0]), Number(endTimeStringSplit[1]), Number(endTimeStringSplit[2]));

          sufix = `${this.localeservice.instantTranslation("WorkWeekService.From")} ${startTime.toLocaleTimeString(this.localeservice.getLocale(),{ hour: '2-digit', minute:'2-digit' })} ${this.localeservice.instantTranslation("WorkWeekService.To")} ${endTime.toLocaleTimeString(this.localeservice.getLocale(), { hour: '2-digit', minute:'2-digit' })}.`;
        }
        else
          sufix =`${this.localeservice.instantTranslation("WorkWeekService.Closed")}.`;

        lines.push(`${prefix} ${sufix}`);
      }

      return lines.join('\n\n');
    }

    return 'Horário de atendimento indisponível.';
  }

  getWeekDayString(weekDay:number)
  {
    switch(weekDay)
    {
      case 0:
        return this.localeservice.instantTranslation("WorkWeekService.Sunday");
      case 1:
        return this.localeservice.instantTranslation("WorkWeekService.Monday");
      case 2:
        return this.localeservice.instantTranslation("WorkWeekService.Tuesday");
      case 3:
        return this.localeservice.instantTranslation("WorkWeekService.Wednesday");
      case 4:
        return this.localeservice.instantTranslation("WorkWeekService.Thursday");
      case 5:
        return this.localeservice.instantTranslation("WorkWeekService.Friday");
      case 6:
        return this.localeservice.instantTranslation("WorkWeekService.Saturday");
      default:
        return "?"
    }
  }
}
